import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { Telefono, TelefonoHistoricoPosiciones, TelefonoUltimaTransmision } from './../../../_entities/telefonos/telefono';

@Injectable({
  providedIn: 'root'
})
export class TelefonosService {

  constructor(private http: HttpClient) { }

  obtenerTelefonos(): Observable<Telefono[]>{
    return this.http.get<Telefono[]>(environment.API_SECURITY + '/api/Telefonos');
  }

  obtenerUltimaTransmisionTelefonos(): Observable<TelefonoUltimaTransmision[]> {
    return this.http.get<TelefonoUltimaTransmision[]>(environment.API_SECURITY + '/api/Telefonos/UltimaTelefonos');
  }

  obtenerReportePosiciones(imei: number, fechaInicio, fechaFinal): Observable<TelefonoHistoricoPosiciones[]> {
    return this.http.get<TelefonoHistoricoPosiciones[]>(environment.API_SECURITY + '/api/Telefonos/' + imei + '/reporte-historico', {
      params: {
        fechaInicio,
        fechaFinal
      }
    });
  }
}
